export default __webpack_public_path__ + "static/media/logo_white.2f3c6d74.svg";